export default __webpack_public_path__ + "static/media/LOGO_JUEGO_4_53.94097b3b.png";